/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, string } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import SingleHero from '../../ContentTypeComponents/HeroSingle/HeroSingle';
import ThirdsHero from '../../ContentTypeComponents/HeroThreeSection/HeroThreeSection';
import BannerGeneric from '../../ContentTypeComponents/GenericBanner/GenericBanner';
import ThreeUpFeature from '../../ContentTypeComponents/ThreeUp/ThreeUp';
import NUpFeature from '../../ContentTypeComponents/NUp/NUp';
import GraphqlSeoFooter from '../GraphqlHomePage/Partials/GraphqlSeoFooter/GraphqlSeoFooter';
import WyngModule from '../../ContentTypeComponents/Wyng/Wyng';
import SeoBlock from '../../ContentTypeComponents/SeoBlock/SeoBlock';
import SubCollection from '../../ContentTypeComponents/SubCollection/SubCollection';
import VideoModule from '../../ContentTypeComponents/Video/Video';
import LinkList from '../../ContentTypeComponents/LinkList/LinkList';
import ZoneTenUI from '../GraphqlHomePage/Partials/Banners/ZoneTenUI';
// helpers
import isEmptyReference from '../../../helpers/contentstack/isEmptyReference';
import QaListContainer from '../../ContentTypeComponents/QaList/QaListContainer';

const DepartmentPageBlock = ({ block, ssrDeviceType }) => {
    const blockKey = Object.keys(block)[0];
    const blockObj = block[blockKey];
    // Run a check to see that a block's references are deployed to the same environment
    if (isEmptyReference(blockObj, blockKey, 'DepartmentPageBlock.js')) return null;

    switch (blockKey) {
        case 'hero_single':
            return <SingleHero data={blockObj} />;

        case 'hero_three_section':
            return <ThirdsHero data={blockObj} />;

        case 'generic_banner':
            return <BannerGeneric data={blockObj} />;

        case '3_up':
            return <ThreeUpFeature data={blockObj} />;

        case 'n_up':
            return <NUpFeature data={blockObj} />;

        case 'seo':
            return <GraphqlSeoFooter data={blockObj} />;

        case 'seo_copy': // GFB
            return <SeoBlock data={blockObj} />;

        case 'wyng':
            return <WyngModule data={blockObj} />;

        case 'subcollection':
            return <SubCollection data={blockObj} />;

        case 'video_module':
            return <VideoModule data={blockObj} />;

        case 'zone_10_banner_v2':
            return <ZoneTenUI data={blockObj} ssrDeviceType={ssrDeviceType} />;
        // Mobile Only
        case 'trending_products':
            return null;

        case 'link_list_module_mobile':
            return <LinkList data={blockObj} type="footermenu" />;

        case 'qa_list':
            return (
                <Grid container justify="center">
                    <Grid item xs={12} sm={12} md={8} lg={8}>
                        <QaListContainer faqSchema data={(blockObj?.reference?.[0] || {})} identifyWidthObj={{ isDesktop: (ssrDeviceType === 'desktop'), isMobile: (ssrDeviceType === 'mobile') }} />
                    </Grid>
                </Grid>
            );

        default:
            console.error('Unknown DepartmentPage block type in DepartmentPageBlock.js');
            return <div>Temp div</div>;
    }
};

DepartmentPageBlock.propTypes = {
    block: object.isRequired,
    ssrDeviceType: string.isRequired,
};

export default DepartmentPageBlock;
